import { QApi } from '../baseQuery';
import {
  GET_QUEUE_MANAGED_LIST,
  GET_USER_QUEUE_JOINED_LIST,
  GET_UI_STATS,
  GET_BLOGS,
  GET_BLOG_DETAIL,
  UNIFIED_SEARCH,
} from '../../config/ApiList';

export const UiApi = QApi.injectEndpoints({
  endpoints: (builder) => ({
    getQueueManagedList: builder.query({
      query: (params) => {
        return {
          url: GET_QUEUE_MANAGED_LIST,
          method: 'GET',
          params,
        };
      },
      invalidatesTags: ['UiApi'],
    }),
    getUserQueueJoinedList: builder.query({
      query: (params) => {
        return {
          url: GET_USER_QUEUE_JOINED_LIST,
          method: 'GET',
          params,
        };
      },
      invalidatesTags: ['UiApi'],
    }),
    getUiStats: builder.query({
      query: (params) => {
        return {
          url: GET_UI_STATS,
          method: 'GET',
          params,
        };
      },
      // REMOVED: invalidatesTags causing excessive API calls
    }),
    getBlogs: builder.query({
      query: (params) => {
        return {
          url: GET_BLOGS + '/',
          method: 'GET',
          params: { rid: Math.random() },
        };
      },
      invalidatesTags: ['UiApi'],
    }),
    getBlogDetail: builder.query({
      query: (blogId) => ({
        url: `${GET_BLOGS}/${blogId}`,
        method: 'GET',
      }),
      invalidatesTags: ['UiApi'],
    }),
    unifiedSearch: builder.query({
      query: (params) => ({
        url: UNIFIED_SEARCH,
        method: 'GET',
        params,
      }),
      // REMOVED: invalidatesTags causing excessive API calls
    }),
    getItemDetails: builder.query({
      query: (itemId) => ({
        url: `/ui/item-details/${itemId}`,
        method: 'GET',
      }),
      invalidatesTags: ['UiApi'],
    }),
  }),
});

export const {
  useGetQueueManagedListQuery,
  useGetUserQueueJoinedListQuery,
  useGetUiStatsQuery,
  useGetBlogsQuery,
  useGetBlogDetailQuery,
  useUnifiedSearchQuery,
  useGetItemDetailsQuery,
} = UiApi;
